import { render, staticRenderFns } from "./SectionLabel.vue?vue&type=template&id=5bb48384&scoped=true"
import script from "./SectionLabel.vue?vue&type=script&lang=js"
export * from "./SectionLabel.vue?vue&type=script&lang=js"
import style0 from "./SectionLabel.vue?vue&type=style&index=0&id=5bb48384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb48384",
  null
  
)

export default component.exports